import { z } from 'zod';
/**
 * Transport envelope.
 *
 * Every endpoint answers with the same shape, so the web client needs exactly one
 * unwrap function and one error branch instead of per-endpoint handling.
 */
/** Stable, machine-readable error codes. The HTTP status is derived from these. */
export const errorCodeSchema = z.enum([
    'VALIDATION_ERROR',
    'UNAUTHORIZED',
    'NOT_FOUND',
    'CONFLICT',
    'PROVIDER_ERROR',
    'RATE_LIMITED',
    'CONFIG_ERROR',
    'INTERNAL_ERROR',
]);
/** Maps an error code to the HTTP status the API responds with. */
export const ERROR_STATUS = {
    VALIDATION_ERROR: 400,
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    CONFLICT: 409,
    RATE_LIMITED: 429,
    PROVIDER_ERROR: 502,
    CONFIG_ERROR: 500,
    INTERNAL_ERROR: 500,
};
/** One field-level validation problem, addressed by a dotted path. */
export const fieldIssueSchema = z.object({
    path: z.string(),
    message: z.string(),
});
export const errorBodySchema = z.object({
    code: errorCodeSchema,
    message: z.string(),
    issues: z.array(fieldIssueSchema).optional(),
    /** Correlates a client-side report with the server log. */
    requestId: z.string().optional(),
});
export const errorResponseSchema = z.object({
    ok: z.literal(false),
    error: errorBodySchema,
});
/** Wraps a payload schema into the success envelope. */
export const successResponse = (data) => z.object({ ok: z.literal(true), data });
/**
 * Systemzustand.
 *
 * Trägt neben der Erreichbarkeit auch den aktiven Marktdaten-Provider. Die
 * Oberfläche braucht diese Information, um kenntlich zu machen, wenn erfundene
 * Kurse dargestellt werden — bei einer Stop-Loss-Anwendung darf das nicht
 * unbemerkt bleiben.
 */
export const systemStatusSchema = z.object({
    status: z.literal('ok'),
    uptimeSeconds: z.number(),
    database: z.enum(['up', 'down']),
    provider: z.object({
        name: z.string(),
        /** True, wenn die Kurse generiert und nicht real sind. */
        isMock: z.boolean(),
    }),
});
//# sourceMappingURL=envelope.js.map